import MemberCardDialogSelector from './membercard-dialog-selector.vue'

MemberCardDialogSelector.install = function (Vue) {
	Vue.component(MemberCardDialogSelector.name, MemberCardDialogSelector);
}

export default MemberCardDialogSelector;